import { useTracking } from '@change-corgi/core-react/tracking';

import { useTopicPageData } from '#src/app/pages/topic/details/pageContext';
import type { TopicPageData } from '#src/app/pages/topic/details/pageContext';

type Result = ModelHookResult<{
	description: string | null;
	name: string;
	hasTopicPhoto: boolean;
	trackSAP: () => void;
	onAccordionToggle: (expanded: boolean, tracking: string) => void;
	structuredData: TopicPageData['structuredData'];
}>;

export function usePageHeading(): Result {
	const {
		data: { description, name, photos, structuredData },
	} = useTopicPageData();

	const track = useTracking();

	const photo = photos.length ? photos[0] : undefined;
	const hasTopicPhoto = !!(photo?.heroMedium.url && photo.metadata?.credit && photo.metadata.source);

	const handleAccordionToggle = (expanded: boolean, tracking: string) => {
		if (expanded) {
			void track(tracking);
		}
	};

	return {
		data: {
			description,
			name,
			hasTopicPhoto,
			structuredData,
			trackSAP: () => {
				void track('topic_sap_click_top');
			},
			onAccordionToggle: (expanded: boolean, tracking: string) => handleAccordionToggle(expanded, tracking),
		},
	};
}
